
import { IEmployeeGroupAbsences } from "../../../domain/employeeGroups/IEmployeeGroupAbsences";
import { mapEmployeeAbsenceInfo } from "./mapEmployeeAbsenceInfo";
export const mapEmployeeGroupAbsences = (x: any): IEmployeeGroupAbsences => ({
    id: x.id,
    name: x.name,
    sortOrder: x.sortOrder,
    available: 0,
    total: 0,
    employees: x.employees.map(mapEmployeeAbsenceInfo)
});
